import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedModule} from 'src/app/shared/shared.module';
import {ServiceCardModule} from '../service-card/service-card.module';
import {CardComponent} from './card.component';


@NgModule({
  declarations: [
    CardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ServiceCardModule,
  ],
  exports: [
    CardComponent
  ],
})
export class CardModule {
}
